import IndexLayout from '../layouts';
import Wrapper from '../components/Wrapper';
import SiteNav from '../components/header/SiteNav';
import { SiteHeader, outer, inner, SiteMain } from '../styles/shared';
import * as React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { PostFullHeader, PostFullTitle, NoImage, PostFull } from '../templates/post';
import { PostFullContent } from '../components/PostContent';
import Footer from '../components/Footer';
import Helmet from 'react-helmet';

//import ShareButtons from '../components/ShareButtons';
import MoreGoodies from '../components/more-goodies/MoreGoodies';
import BackToTop from '../components/BackToTop';

// https://andi-siess.de/rgb-to-color-temperature/
const colorTemperatureTable = {
  1000: 'rgb(255, 56, 0)',
  1100: 'rgb(255, 71, 0)',
  1200: 'rgb(255, 83, 0)',
  1300: 'rgb(255, 93, 0)',
  1400: 'rgb(255, 101, 0)',
  1500: 'rgb(255, 109, 0)',
  1600: 'rgb(255, 115, 0)',
  1700: 'rgb(255, 121, 0)',
  1800: 'rgb(255, 126, 0)',
  1900: 'rgb(255, 131, 0)',
  2000: 'rgb(255, 138, 18)',
  2100: 'rgb(255, 142, 33)',
  2200: 'rgb(255, 147, 44)',
  2300: 'rgb(255, 152, 54)',
  2400: 'rgb(255, 157, 63)',
  2500: 'rgb(255, 161, 72)',
  2600: 'rgb(255, 165, 79)',
  2700: 'rgb(255, 169, 87)',
  2800: 'rgb(255, 173, 94)',
  2900: 'rgb(255, 177, 101)',
  3000: 'rgb(255, 180, 107)',
  3100: 'rgb(255, 184, 114)',
  3200: 'rgb(255, 187, 120)',
  3300: 'rgb(255, 190, 126)',
  3400: 'rgb(255, 193, 132)',
  3500: 'rgb(255, 196, 137)',
  3600: 'rgb(255, 199, 143)',
  3700: 'rgb(255, 201, 148)',
  3800: 'rgb(255, 204, 153)',
  3900: 'rgb(255, 206, 159)',
  4000: 'rgb(255, 209, 163)',
  4100: 'rgb(255, 211, 168)',
  4200: 'rgb(255, 213, 173)',
  4300: 'rgb(255, 215, 177)',
  4400: 'rgb(255, 217, 182)',
  4500: 'rgb(255, 219, 186)',
  4600: 'rgb(255, 221, 190)',
  4700: 'rgb(255, 223, 194)',
  4800: 'rgb(255, 225, 198)',
  4900: 'rgb(255, 227, 202)',
  5000: 'rgb(255, 228, 206)',
  5100: 'rgb(255, 230, 210)',
  5200: 'rgb(255, 232, 213)',
  5300: 'rgb(255, 233, 217)',
  5400: 'rgb(255, 235, 220)',
  5500: 'rgb(255, 236, 224)',
  5600: 'rgb(255, 238, 227)',
  5700: 'rgb(255, 239, 230)',
  5800: 'rgb(255, 240, 233)',
  5900: 'rgb(255, 242, 236)',
  6000: 'rgb(255, 243, 239)',
  6100: 'rgb(255, 244, 242)',
  6200: 'rgb(255, 245, 245)',
  6300: 'rgb(255, 246, 247)',
  6400: 'rgb(255, 248, 251)',
  6500: 'rgb(255, 249, 253)',
  6600: 'rgb(254, 249, 255)',
  6700: 'rgb(252, 247, 255)',
  6800: 'rgb(249, 246, 255)',
  6900: 'rgb(247, 245, 255)',
  7000: 'rgb(245, 243, 255)',
  7100: 'rgb(243, 242, 255)',
  7200: 'rgb(240, 241, 255)',
  7300: 'rgb(239, 240, 255)',
  7400: 'rgb(237, 239, 255)',
  7500: 'rgb(235, 238, 255)',
  7600: 'rgb(233, 237, 255)',
  7700: 'rgb(231, 236, 255)',
  7800: 'rgb(230, 235, 255)',
  7900: 'rgb(228, 234, 255)',
  8000: 'rgb(227, 233, 255)',
  8100: 'rgb(225, 232, 255)',
  8200: 'rgb(224, 231, 255)',
  8300: 'rgb(222, 230, 255)',
  8400: 'rgb(221, 230, 255)',
  8500: 'rgb(220, 229, 255)',
  8600: 'rgb(218, 229, 255)',
  8700: 'rgb(217, 227, 255)',
  8800: 'rgb(216, 227, 255)',
  8900: 'rgb(215, 226, 255)',
  9000: 'rgb(214, 225, 255)',
  9100: 'rgb(212, 225, 255)',
  9200: 'rgb(211, 224, 255)',
  9300: 'rgb(210, 223, 255)',
  9400: 'rgb(209, 223, 255)',
  9500: 'rgb(208, 222, 255)',
  9600: 'rgb(207, 221, 255)',
  9700: 'rgb(207, 221, 255)',
  9800: 'rgb(206, 220, 255)',
  9900: 'rgb(205, 220, 255)',
  10000: 'rgb(207, 218, 255)',
  10100: 'rgb(207, 218, 255)',
  10200: 'rgb(206, 217, 255)',
  10300: 'rgb(205, 217, 255)',
  10400: 'rgb(204, 216, 255)',
  10500: 'rgb(204, 216, 255)',
  10600: 'rgb(203, 215, 255)',
  10700: 'rgb(202, 215, 255)',
  10800: 'rgb(202, 214, 255)',
  10900: 'rgb(201, 214, 255)',
  11000: 'rgb(200, 213, 255)',
  11100: 'rgb(200, 213, 255)',
  11200: 'rgb(199, 212, 255)',
  11300: 'rgb(198, 212, 255)',
  11400: 'rgb(198, 212, 255)',
  11500: 'rgb(197, 211, 255)',
  11600: 'rgb(197, 211, 255)',
  11700: 'rgb(197, 210, 255)',
  11800: 'rgb(196, 210, 255)',
  11900: 'rgb(195, 210, 255)',
  12000: 'rgb(195, 209, 255)',
};

const FactsBox = styled.div`
  margin-top: 15rem;
  background: #EFFAF2;
  border-radius: 8px;
  padding: 1.3rem 1.3rem 0.45rem;

  @media (max-width: 750px) {
    padding: 0.1rem 0.1rem 0.1rem;
  }

  li:first-letter {
    color: #ACE3BA;
  }

  h3 {
    padding-top: 0;
  }
`;

const FinalMessage = styled.h2`
  margin-top: 3rem;
  padding: 2rem 3.5rem;
  max-width: 600px !important;
  display: inline;
  border-radius: 25px;
  background: rgba(255, 255, 255, 0.4);

  @media (max-width: 650px) {
    font-size: 2rem !important;
    padding: 1rem;
    display: block;
  }
`;

const PageTemplate = css`
  .site-main {
    background #fff;
    padding-bottom: 4vw;
  }

  .post-content {
    max-width: 1000px;
    margin: 0 auto;
  }
  .post-full-content {
    background: transparent;
  }
  h2::before {
    all: unset !important;
  }
  h3 {
    text-decoration: none !important;
    padding-top: 5rem;
    text-align: center;
  }
  .post-content h5 {
    font-size: 2.2rem;
    padding: 0.5em 0;
  }
  h1::before {
    content: " ";
    background: linear-gradient(45deg, orange, blue);
    width: 50px;
    height: 50px;
    display: inline-block;
    vertical-align: bottom;
    margin-right: 2rem;
    border-radius: 50%;
  } 
  hr {
    max-width: 200px;
    margin: 6rem auto 9rem !important;
    border-top: 4px solid #32BA55;
  }

  @media (max-width: 650px) {
    .post-content h5 {
      font-size: 1.8rem;
    }
    .hide-small {
      display: none;
    }
    h1::before {
      display: block;
      margin: 0 auto 2rem;
    } 
    hr {
      max-width: 100px;
      margin: 1rem auto 4rem !important;
      border-top: 4px solid #32BA55;
    }
  }
`;

const Range = styled.input`
  width: 100%;
  -webkit-appearance: none;
  margin: 6rem 0;
  background: transparent;

  :focus {
    outline: none;
  }
  ::-webkit-slider-runnable-track {
    width: 100%;
    height: 12.8px;
    cursor: pointer;
    animate: 0.2s;
    box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
    background: rgba(155, 89, 182, 0.4);
    border-radius: 15px;
    border: 0px solid #000101;
  }
  ::-webkit-slider-thumb {
    // box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
    border: 0px solid #000000;
    height: 40px;
    width: 40px;
    border-radius: 20px;
    background: radial-gradient(#7e59c1, #382757);
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -13.6px;
  }
  :focus::-webkit-slider-runnable-track {
    background: rgba(155, 89, 182, 0.6);
  }
  ::-moz-range-track {
    width: 100%;
    height: 12.8px;
    cursor: pointer;
    animate: 0.2s;
    // box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
    background: rgba(155, 89, 182, 0.4);
    border-radius: 15px;
    border: 0px solid #000101;
  }
  ::-moz-range-thumb {
    box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
    border: 0px solid #000000;
    height: 40px;
    width: 40px;
    border-radius: 20px;
    background: radial-gradient(#7e59c1, #382757);
    cursor: pointer;
  }
  ::-ms-track {
    width: 100%;
    height: 12.8px;
    cursor: pointer;
    animate: 0.2s;
    background: transparent;
    border-color: transparent;
    border-width: 39px 0;
    color: transparent;
  }
  ::-ms-fill-lower {
    background: #ac51b5;
    border: 0px solid #000101;
    border-radius: 50px;
    box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
  }
  ::-ms-fill-upper {
    background: #ac51b5;
    border: 0px solid #000101;
    border-radius: 50px;
    box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
  }
  ::-ms-thumb {
    box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
    border: 0px solid #000000;
    height: 20px;
    width: 39px;
    border-radius: 20px;
    background: #65001c;
    cursor: pointer;
  }
  :focus::-ms-fill-lower {
    background: #ac51b5;
  }
  :focus::-ms-fill-upper {
    background: #ac51b5;
  }
`;

const ShortcutBtn = styled.button`
  background: white;
  margin: 0.75rem;
  padding: 0.3rem 2rem;
  border-radius: 3px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

  @media (max-width: 650px) {
    font-size: 1.4rem;
    padding: 0.3rem 0.7rem;
    margin: 0.3rem;
  }
`;

interface ColorTempChartState {
  currentValue: number;
  wbValue: number;
  finalMessage: string;
}

class ColorTempChart extends React.Component<undefined, ColorTempChartState> {
  rangeInput;

  state = {
    currentValue: 5000,
    wbValue: 5000,
    finalMessage: '👍 Image will be neutral (whites will be white)',
  };

  componentDidMount = () => {
    document.body.style.backgroundColor = colorTemperatureTable[5000];
    const siteMain: HTMLElement | null = document.querySelector('#site-main');
    // tslint:disable-next-line:no-non-null-assertion
    siteMain!.style.backgroundColor = colorTemperatureTable[5000];
    // tslint:disable-next-line:no-non-null-assertion
    document.querySelector('footer')!.style.backgroundColor = colorTemperatureTable[5000];
  };

  componentDidUpdate = () => {
    document.body.style.backgroundColor = colorTemperatureTable[this.state.currentValue];
    const siteMain: HTMLElement | null = document.querySelector('#site-main');
    // tslint:disable-next-line:no-non-null-assertion
    siteMain!.style.backgroundColor = colorTemperatureTable[this.state.currentValue];
    // tslint:disable-next-line:no-non-null-assertion
    document.querySelector('footer')!.style.backgroundColor =
      colorTemperatureTable[this.state.currentValue];
  };

  componentWillUnmount = () => {
    document.body.style.backgroundColor = '#fff';
    const siteMain: HTMLElement | null = document.querySelector('#site-main');

    // tslint:disable-next-line:no-non-null-assertion
    siteMain!.style.backgroundColor = 'white';
    // tslint:disable-next-line:no-non-null-assertion
    // document.querySelector('#site-main')!.style.backgroundColor = '#e8e2f2';
  };

  handleChange = evt => {
    const mainEl2: HTMLElement | null = document.querySelector('#site-main');
    document.body.style.backgroundColor = colorTemperatureTable[evt.target.value];

    if (mainEl2) {
      mainEl2.style.backgroundColor = colorTemperatureTable[evt.target.value];
    }

    this.setState({ currentValue: +evt.target.value });

    if (+evt.target.value === this.state.wbValue) {
      this.setState({ finalMessage: '👍 Image will be neutral (whites will be white)' });
    } else if (+evt.target.value < this.state.wbValue) {
      if (this.state.wbValue - +evt.target.value >= 1500) {
        this.setState({ finalMessage: '🔥🔥 Image will appear warmer' });
      } else {
        this.setState({ finalMessage: '🔥 Image will appear warmer' });
      }
    } else if (+evt.target.value > this.state.wbValue) {
      if (+evt.target.value - this.state.wbValue >= 1500) {
        this.setState({ finalMessage: '❄️❄️ Image will appear cooler' });
      } else {
        this.setState({ finalMessage: '❄️ Image will appear cooler' });
      }
    }
  };

  handleWbChange = evt => {
    if (+evt.target.value === this.state.currentValue) {
      this.setState({ finalMessage: '👍 Image will be neutral (whites will be white)' });
    } else if (+evt.target.value > this.state.currentValue) {
      if (+evt.target.value - this.state.currentValue >= 1500) {
        this.setState({ finalMessage: '🔥🔥 Image will appear warmer' });
      } else {
        this.setState({ finalMessage: '🔥 Image will appear warmer' });
      }
    } else if (+evt.target.value < this.state.currentValue) {
      if (this.state.currentValue - +evt.target.value >= 1500) {
        this.setState({ finalMessage: '❄️❄️ Image will appear cooler' });
      } else {
        this.setState({ finalMessage: '❄️ Image will appear cooler' });
      }
    }

    this.setState({ wbValue: +evt.target.value });
  };

  setCurrentValue = val => {
    this.setState({ currentValue: +val });

    if (+val === this.state.wbValue) {
      this.setState({ finalMessage: '👍 Image will be neutral (whites will be white)' });
    } else if (+val < this.state.wbValue) {
      if (this.state.wbValue - +val >= 1500) {
        this.setState({ finalMessage: '🔥🔥 Image will appear warmer' });
      } else {
        this.setState({ finalMessage: '🔥 Image will appear warmer' });
      }
    } else if (+val > this.state.wbValue) {
      if (+val - this.state.wbValue >= 1500) {
        this.setState({ finalMessage: '❄️❄️ Image will appear cooler' });
      } else {
        this.setState({ finalMessage: '❄️ Image will appear cooler' });
      }
    }
  };

  setCurrentWb = wb => {
    this.setState({ wbValue: +wb });

    if (+wb === this.state.currentValue) {
      this.setState({ finalMessage: '👍 Image will be neutral (whites will be white)' });
    } else if (+wb > this.state.currentValue) {
      if (+wb - this.state.currentValue >= 1500) {
        this.setState({ finalMessage: '🔥🔥 Image will appear warmer' });
      } else {
        this.setState({ finalMessage: '🔥 Image will appear warmer' });
      }
    } else if (+wb < this.state.currentValue) {
      if (this.state.currentValue - +wb >= 1500) {
        this.setState({ finalMessage: '❄️❄️ Image will appear cooler' });
      } else {
        this.setState({ finalMessage: '❄️ Image will appear cooler' });
      }
    }
  };

  render() {
    return (
      <IndexLayout>
        <Helmet>
          <title>Interactive Color Temperature Chart | Giggster</title>
          <meta
            name="description"
            content="Ideal as a tool for photography and videography, this free tool will allow you to preview the different light color temperatures and see how you should set your white balance."
          />

          <meta property="og:site_name" content="Giggster Guide" />
          <meta property="og:type" content="article" />
          <meta property="og:title" content="Interactive Color Temperature Chart" />
          <meta
            property="og:description"
            content="Ideal as a tool for photography and videography, this free tool will allow you to preview the different light color temperatures and see how you should set your white balance."
          />
          <meta property="og:url" content="https://giggster.com/guide/color-temperature-chart/" />
          <meta
            property="og:image"
            content="https://giggster.com/guide/covers/color-temperature-chart.png"
          />
          <meta property="article:publisher" content="https://www.facebook.com/giggsterHQ" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Interactive Color Temperature Chart" />
          <meta
            name="twitter:description"
            content="Ideal as a tool for photography and videography, this free tool will allow you to preview the different light color temperatures and see how you should set your white balance."
          />
          <meta name="twitter:url" content="https://giggster.com/guide/color-temperature-chart/" />
          <meta
            name="twitter:image"
            content="https://giggster.com/guide/covers/color-temperature-chart.png"
          />
          <meta name="twitter:site" content="@Giggster" />
          <meta name="twitter:creator" content="@Giggster" />
        </Helmet>
        <Wrapper css={PageTemplate}>
          <header css={[outer, SiteHeader]}>
            <div css={inner}>
              <SiteNav />
            </div>
          </header>
          <main id="site-main" className="site-main" css={[SiteMain, outer]}>
            <article className="post page" css={[PostFull, NoImage]}>
              <PostFullHeader>
                <PostFullTitle>Interactive Color Temperature Chart</PostFullTitle>
                <h2>Preview the color of different light source color temperatures</h2>
                {/*<ShareButtons
                  title={'Interactive Color Temperature Chart'}
                  slug={'/color-temperature-chart/'}
                  imgSrc={'covers/color-temperature-chart.png'}
                />*/}
              </PostFullHeader>

              <PostFullContent className="post-full-content">
                <div className="post-content text-center">
                  <p>
                    Below you can drag the slider or click on some of the preset buttons to see what
                    color a certain color temperature value looks like.
                  </p>
                  <h2>Color Temperature (light source): {this.state.currentValue} K</h2>
                  {/* tslint:disable-next-line:react-this-binding-issue */}
                  <ShortcutBtn onClick={() => this.setCurrentValue(3200)}>
                    <span className="hide-small">💡</span> Tungsten (3200K)
                  </ShortcutBtn>
                  {/* tslint:disable-next-line:react-this-binding-issue */}
                  <ShortcutBtn onClick={() => this.setCurrentValue(4000)}>
                    Fluorescent (4000K)
                  </ShortcutBtn>
                  {/* tslint:disable-next-line:react-this-binding-issue */}
                  <ShortcutBtn onClick={() => this.setCurrentValue(5000)}>
                    <span className="hide-small">📸</span> Flash (5000K)
                  </ShortcutBtn>
                  {/* tslint:disable-next-line:react-this-binding-issue */}
                  <ShortcutBtn onClick={() => this.setCurrentValue(5600)}>
                    <span className="hide-small">☀️</span> Daylight (5600K)
                  </ShortcutBtn>

                  {/* tslint:disable-next-line:react-this-binding-issue */}
                  <ShortcutBtn onClick={() => this.setCurrentValue(6000)}>
                    <span className="hide-small">☁️</span> Cloudy (6000K)
                  </ShortcutBtn>

                  {/* tslint:disable-next-line:react-this-binding-issue */}
                  <ShortcutBtn onClick={() => this.setCurrentValue(7000)}>
                    Shade (7000K)
                  </ShortcutBtn>
                  {/* tslint:disable-next-line:react-this-binding-issue */}
                  <ShortcutBtn onClick={() => this.setCurrentValue(10000)}>
                    Blue Sky (10000K)
                  </ShortcutBtn>
                  <Range
                    type="range"
                    min="1000"
                    max="12000"
                    step="100"
                    value={this.state.currentValue}
                    onChange={this.handleChange}
                  />
                  <hr />
                  <h2>White Balance Setting (camera): {this.state.wbValue} K</h2>
                  <p>
                    Adjust the white balance in relation to the selected color temperature and
                    you'll see if the image will be neutral, cool or warm.
                  </p>
                  {/* tslint:disable-next-line:react-this-binding-issue */}
                  <ShortcutBtn onClick={() => this.setCurrentWb(3200)}>
                    <span className="hide-small">💡</span> Tungsten (3200K)
                  </ShortcutBtn>
                  {/* tslint:disable-next-line:react-this-binding-issue */}
                  <ShortcutBtn onClick={() => this.setCurrentWb(4000)}>
                    Fluorescent (4000K)
                  </ShortcutBtn>
                  {/* tslint:disable-next-line:react-this-binding-issue */}
                  <ShortcutBtn onClick={() => this.setCurrentWb(5000)}>
                    <span className="hide-small">📸</span> Flash (5000K)
                  </ShortcutBtn>
                  {/* tslint:disable-next-line:react-this-binding-issue */}
                  <ShortcutBtn onClick={() => this.setCurrentWb(5600)}>
                    <span className="hide-small">☀️</span> Daylight (5600K)
                  </ShortcutBtn>

                  {/* tslint:disable-next-line:react-this-binding-issue */}
                  <ShortcutBtn onClick={() => this.setCurrentWb(6000)}>
                    <span className="hide-small">☁️</span> Cloudy (6000K)
                  </ShortcutBtn>

                  {/* tslint:disable-next-line:react-this-binding-issue */}
                  <ShortcutBtn onClick={() => this.setCurrentWb(7000)}>Shade (7000K)</ShortcutBtn>
                  {/* tslint:disable-next-line:react-this-binding-issue */}
                  <ShortcutBtn onClick={() => this.setCurrentWb(10000)}>
                    Blue Sky (10000K)
                  </ShortcutBtn>
                  <Range
                    type="range"
                    min="1000"
                    max="12000"
                    step="100"
                    value={this.state.wbValue}
                    onChange={this.handleWbChange}
                  />
                  <FinalMessage>{this.state.finalMessage}</FinalMessage>

                  <FactsBox>
                    <h3>💡 Some facts:</h3>
                    <ul>
                      <li>
                        &#9673; The subject of{' '}
                        <a href="https://en.wikipedia.org/wiki/Color_temperature">
                          color temperature
                        </a>{' '}
                        gets sciency really quickly, but in a nutshell color temperature is the
                        color of the light source.
                      </li>
                      <li>
                        &#9673; Color temperature is measured in degrees kelvin (abbreviated with{' '}
                        <strong>K</strong>).
                      </li>
                      <li>
                        &#9673; Lower color temperature sources appear warmer and more orange while
                        higher color temperature sources appear cooler and more blue.
                      </li>
                      <li>
                        &#9673; White balance is the camera's way to neutralize the color
                        temperature so that whites appear white. It works in the opposite direction
                        to color temperature (higher white balance settings for warmer images, lower
                        white balance setting for cooler images).
                      </li>
                      <li>
                        &#9673; Normally you'll want to set your white balance to match the color
                        temperature of the source, for a neutral images. You can however make
                        creative use of white balance for cooler or warmer results and create a
                        different mood in your images.
                      </li>
                      <li>
                        &#9673; You can also make use of colored gels, color temperature orange
                        (CTO) and color temperature blue (CTB), to color correct certain areas of
                        your scene or for creative effects.
                      </li>
                      <li>
                        &#9673; When shooting RAW, the white balance setting in your camera is not
                        as important because white balance can always be changed in post-production.
                      </li>
                    </ul>
                  </FactsBox>
                  <h5>
                    * Thanks to{' '}
                    <a href="https://andi-siess.de/rgb-to-color-temperature/">Andreas Siess</a> for
                    having compiled the raw data that make this tool possible!
                  </h5>
                  <h5>
                    * The color temperature presets provided here (e.g.: Flash = 5000K) are just
                    approximations and the actual values are often in a range instead of being a
                    clear-cut value.
                  </h5>
                </div>
              </PostFullContent>
            </article>
            <MoreGoodies slug="color-temperature-chart" />
          </main>
          <BackToTop />
          <Footer />
        </Wrapper>
      </IndexLayout>
    );
  }
}

export default ColorTempChart;
